// Generated file: Do not edit 
// generated from @taqueria-protocol-types
    
import { TaqError, toFutureParseErr, toFutureParseUnknownErr, toParseErr, toParseUnknownErr } from '@taqueria/protocol/TaqError';
import { FutureInstance, resolve, reject } from 'fluture';
import { ZodError } from 'zod';
import { SandboxAccount } from '@taqueria/protocol/types';
import { SandboxAccount as SandboxAccountStrict } from '@taqueria/protocol/out/types-strict';
import { sandboxAccountSchema } from '@taqueria/protocol/out/types-zod';

export type { SandboxAccountStrict as SandboxAccount };

export const from = (input: unknown): SandboxAccountStrict => {
	try {
		return sandboxAccountSchema.parse(input) as SandboxAccountStrict;
	}
	catch (previous: unknown) {
		if (previous instanceof ZodError) {
			const msgs: string[] = previous.errors.reduce(
				(retval, issue) => {
					const path = issue.path.join(' → ');
					const msg = path + ': ' + issue.message;
					return [...retval, msg];
				},
				["SandboxAccount is invalid:"],
			);
			const validationErr = msgs.join('\n') + '\n';
			throw toParseErr(previous, validationErr);
		}
		throw toParseUnknownErr(previous, "There was a problem trying to parse a SandboxAccount.")
	}
    
};

export const create = (input: SandboxAccount): SandboxAccountStrict => from(input);

export const of = (input: unknown): FutureInstance<TaqError, SandboxAccountStrict> => {
	try {
		return resolve(from(input))
	}
	catch (err){
		return reject(err) as FutureInstance<TaqError, never>
	}
};

export const make = (input: Omit<SandboxAccountStrict, '__type'>): FutureInstance<TaqError, SandboxAccountStrict> => of(input);

// TEMP: for interoperation with old protocol types during transition
export const schemas = {
	rawSchema: sandboxAccountSchema,
	schema: sandboxAccountSchema.transform(val => val as SandboxAccountStrict),
};
export const rawSchema = schemas.rawSchema;
export const internalSchema = sandboxAccountSchema;

export type t = SandboxAccountStrict;
        